<template>
    <Modal ref="modal">
      <div el="list-column-between">
        <h3 el>Delete User</h3>
        <span class="material-icons" @click="$refs.modal.toggle()" el="icon"
          >close</span
        >
      </div>
      <div el="list md">
        <p el>Are you sure you want to delete this user?</p>
        <div el="list-column-between">
          <div></div>
          <div>
            <div el="btn" @click="deleteUser(selectedUser.id)">Delete User</div>
          </div>
        </div>
      </div>
    </Modal>
  <div el="list" style="--gap:16px;max-width:1200px;">
    <div el="list-column-between xxsm" class="v-center">
      <div el="tabs-underline">
        <div
          :class="{ active: users.filters.all }"
          @click="changeFilter('all')"
        >
          All
        </div>
        <div
          :class="{ active: users.filters.student }"
          @click="changeFilter('student')"
        >
          Student
        </div>
        <div
          :class="{ active: users.filters.admin }"
          @click="changeFilter('admin')"
        >
          Admins
        </div>
        <div
          :class="{ active: users.filters.blocked }"
          @click="changeFilter('blocked')"
        >
          Blocked
        </div>
      </div>
      <span
        class="material-icons"
        title="Export Users: CSV"
        el="icon"
        @click="downloadUserCSV"
        >save_alt</span
      >
    </div>
    <div :class="{ 'dynamic-table1': true, selected: selectedUser != null }">
      <div style="padding:20px;">
        <!-- <div el="indeterminate-progress"></div> -->
        <div el="input-list">
          <label el="input" class="search">
            <input
              v-model="users.search"
              type="text"
              name="input"
              placeholder="Search..."
              el
            />
            <span class="material-icons">search</span>
          </label>
        </div>
      </div>
      <div v-if="selectedUser == null"></div>
      <div
        v-else
        style="grid-row: span 2;display: grid;grid-template-rows: max-content 1fr;overflow:hidden;"
      >
        <div
          el="list"
          style="--gap:8px;padding-top:24px;--border-bottom: 1px solid #ccc;--hover-border-bottom:var(--border-bottom);--pressed-border-bottom:var(--border-bottom);"
        >
          <!-- <div el="indeterminate-progress"></div> -->
          <div
            el="list-column-between"
            style="padding:0 24px;"
            class="v-center"
          >
            <div el="list-column" class="v-center">
              <h4 el>
                {{ selectedUser.displayName }}
              </h4>
              <!-- <span class="material-icons" el="icon-2ry">edit</span> -->
            </div>
            <div el="list-column" class="v-center" style="--gap: 16px;">
            <div
                el="toggle"
                :class="{ active: selectedUser.blockUser }"
                @click="toggleActive"
              >
                disable
              </div>
              <!-- <div
                el="btn-2ry"
                v-if="!selectedUser.approvedAccount"
                @click="setAccess(selectedUser.id, true)"
              >
                Grant Access
              </div>
              <div
                el="btn-2ry"
                v-else
                @click="setAccess(selectedUser.id, false)"
              >
                Revoke Access
              </div> -->
              <!-- <span class="material-icons" el="icon-2ry" @click="deselectUser">close</span> -->
            </div>
          </div>
          <div
            el="list-column-between"
            style="padding:0 24px;padding-bottom:16px;"
            class="v-center"
          >
            <div el="list-column" class="v-center">
              <!-- <div el="status-pending">admin</div> -->
              <!-- <div
                el="toggle"
                :class="{ active: selectedUser.permissions.includes('admin') }"
                @click="toggleAdmin"
              >
                admin
              </div> -->
              <!-- <div el="flat-btn-2ry" style="padding: 0;">
                                <span class="material-icons">radio_button_unchecked</span>
                                <span>Select All</span>
                            </div> -->
            </div>
            <div el="list-column xxsm" class="v-center">
              <span
                class="material-icons"
                el="icon"
                @click="users.editSelectedUser = true"
                v-if="!users.editSelectedUser"
                >edit</span
              >
              <!-- <span
                class="material-icons"
                el="icon"
                @click="$refs.modal.toggle()"
                >delete</span
              > -->
              <!-- <div el="flat-btn-2ry">
                                <span class="material-icons">file_copy</span>
                                <span>Duplicate</span>
                            </div> -->
              <!-- <span class="material-icons" el="icon-2ry">view_module</span>
                            <span class="material-icons" el="icon-2ry">view_list</span> -->
            </div>
          </div>
        </div>
        <div style="overflow: auto;">
          <!-- User Details -->
          <div el="list sm" style="padding:24px;">
            <Text el="h3">Account Info</Text>
            <div el="list xxsm" v-if="!users.editSelectedUser">
              <List el="column xsm" class="v-center" v-if="selectedUser.phone">
                <span class="material-icons">call</span>
                <Text el="bold">{{ selectedUser.phone }}</Text>
              </List>
              <List el="column xsm" class="v-center">
                <span class="material-icons">email</span>
                <Text el="bold">{{ selectedUser.email }}</Text>
              </List>
              <br>
              <div>
                <div
                el="toggle"
                :class="{ active: selectedUser.student }"
                @click="toggleStudent"
              >
                student
              </div>
              </div>
              <br>
              <List el="xxsm">
                <Text el="h3">Assign Groups</Text>
                <List el="column xxsm" class="tagContainer">
                  <div v-for="group in groups.list" :class="{active: selectedUser.groups.includes(group)}" :key="group" @click="toggleGroup(group)">{{group}}</div>
                </List>
              </List>
              <!-- <p el><b>Account Type:</b> {{ selectedUser.accountType }}</p> -->
              <!-- <p el>
                <b>Created on:</b> {{ formatDate(selectedUser.createdOn) }}
              </p> -->
              <p
                el
                v-if="selectedUser.notes != null && selectedUser.notes != ''"
              >
                <b>Notes:</b> {{ selectedUser.notes }}
              </p>
            </div>
            <div el="list xxsm" v-else>
              <!-- <div el>
                <b>Display Name: </b
                ><input
                  type="text"
                  class="input-text"
                  v-model.trim="selectedUser.displayName"
                />
              </div> -->
              <div el>
                <b>Phone: </b
                ><input
                  type="text"
                  class="input-text"
                  v-model.trim="selectedUser.phone"
                />
              </div>
              <p el>
                <b>Address: </b
                ><input
                  type="text"
                  class="input-text"
                  v-model.trim="selectedUser.address"
                />
              </p>
              <p el>
                <b>Stripe Customer ID: </b
                ><input
                  type="text"
                  class="input-text"
                  v-model.trim="selectedUser.stripeCustomerID"
                />
              </p>
              <!-- <p el>
                <b>Account Type: </b>
                <select v-model="selectedUser.accountType" class="input-select">
                  <option value="resident">Resident</option>
                  <option value="renter">Renter</option>
                </select>
              </p> -->
              <p el>
                <b>Notes: </b
                ><input
                  type="text"
                  class="input-text"
                  v-model.trim="selectedUser.notes"
                />
              </p>

              <div el="list-column xxsm">
                <div el="btn-2ry" @click="users.editSelectedUser = false">
                  Cancel
                </div>
                <div el="btn" @click="updateUser">Save</div>
              </div>
            </div>

            <!-- <Text el="h3">History</Text>
            <div el="tabs-underline">
              <div class="active">Booking</div>
              <div>Products</div>
              <div>Gift Cards</div>
            </div> -->
            <!-- <div el="list xxsm">
                            <div el="list-column">
                                
                            </div>
                        </div> -->
          </div>
        </div>
      </div>
      <div style="overflow: auto;">
        <table el="table">
          <colgroup>
            <col style="width:150px;" />
            <col style="width:250px;"/>
            <col />
          </colgroup>
          <thead>
            <th>Name</th>
            <th>Email</th>
            <th>Groups</th>
          </thead>
          <tbody>
            <tr
              v-for="item in filteredUsers"
              :key="item"
              @click="selectUser(item.id)"
              :class="{ active: users.selected == item.id }"
            >
              <td>{{ item.displayName }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.groups? item.groups.join(', ') : 'none' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { db } from "../firebase";
import Modal from "@/components/Modal.vue";
import Papa from "papaparse";
import { collection, query, where, onSnapshot, doc, setDoc, deleteDoc } from "firebase/firestore"; 

export default {
  name: "Messages",
  props: ["title"],
  components: {
    Modal,
  },
  data() {
    return {
      groups: this.$store.state.main.groups,
      user: this.$store.state.main.user,
      users: {
        filters: {
          approvedAccount: true,
          all: true,
          student: false,
          admin: false,
          blocked: false
        },
        selected: null,
        editSelectedUser: false,
        search: "",
        //   filters:{

        //   },

        list: [
          {
            firstName: "First",
            lastName: "Last",
            email: "name@email.com",
            address: "address",
            phone: "phone",
            approvedAccount: false,
            permissions: [],
            role: "",
            createdOn: Date.now(),
          },
        ],
      },
    };
  },
  methods: {
    selectUser(id) {
      this.users.selected = id;
    },
    deselectUser() {
      this.users.selected = null;
    },
    // firebase methods
    getUserData() {
      var x = this;
      let users = collection(db, "users"),
        q = null;

      if (x.users.filters.admin) {
        q = query(users, where("permissions", "array-contains", "admin"));
      } else if(x.users.filters.blocked){
        q = query(users, where("blockUser", "==", true));
      } else if(x.users.filters.student){
        q = query(users, where("student", "==", true));
      } else {
        // q = query(users, where("accountType", "==", 'client'));
        q = query(users);
      }

      x.users.list = {};

      onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
            let data = doc.data();
            data.id = doc.id;
            x.users.list[data.id] = data;
        });
      });
    },
    async setAccess(id, val) {
      let docRef = doc(db, "users", id);
      await setDoc(docRef, {
        approvedAccount: val,
      }, { merge: true });
    },
    async toggleAdmin() {
      var x = this;
      let userPer = x.selectedUser.permissions;
      let i = userPer.indexOf("admin");
      if (i >= 0) {
        userPer.splice(i, 1);
      } else {
        userPer.push("admin");
      }
      let docRef = doc(db, "users", x.selectedUser.id);
      await setDoc(docRef, {
          permissions: userPer,
      }, { merge: true }).then(() => {
        console.log("Document successfully updated!");
        x.selectedUser.permissions = userPer;
      });
    },
    async toggleGroup(val) {
      var x = this;
      let groups = x.selectedUser.groups;
      let i = groups.indexOf(val);
      if (i >= 0) {
        groups.splice(i, 1);
      } else {
        groups.push(val);
      }
      let docRef = doc(db, "users", x.selectedUser.id);
      await setDoc(docRef, {
          groups: groups,
      }, { merge: true }).then(() => {
        console.log("Document successfully updated!");
        if(x.selectUser.uid == x.user.uid){
          x.user.groups = groups;
        }
        x.selectedUser.groups = groups;
      });
    },
    async toggleActive() {
      var x = this;
      let blockUser = !x.selectedUser.blockUser;
      let docRef = doc(db, "users", x.selectedUser.id);
      await setDoc(docRef, {
          blockUser: blockUser,
      }, { merge: true }).then(() => {
        console.log("Document successfully updated!");
        x.selectedUser.blockUser = blockUser;
      });
    },
    async toggleStudent() {
      var x = this;
      let student = !x.selectedUser.student;
      let docRef = doc(db, "users", x.selectedUser.id);
      await setDoc(docRef, {
          student: student,
      }, { merge: true }).then(() => {
        console.log("Document successfully updated!");
        x.selectedUser.student = student;
      });
    },
    async updateUser() {
      var x = this;
      const userRef = doc(db, 'users', this.selectedUser.id);
      await setDoc(userRef, {
          phone: x.selectedUser.phone || "",
          address: x.selectedUser.address || "",
          // accountType: x.selectedUser.accountType,
          notes: x.selectedUser.notes || "",
          stripeCustomerID: x.selectedUser.stripeCustomerID || "",
        }, { merge: true });

      x.users.editSelectedUser = false;
      console.log("Document successfully updated!");
    },
    async deleteUser(uid) {
      var x = this;
      await deleteDoc(doc(db, "users", uid));
      x.$refs.module.toggle();
      x.getUserData();
    },
    formatDate(date) {
      let d = new Date(date);
      return d.toLocaleString("en-US");
    },
    changeFilter(val) {
      // switch(val){
      //   case 'admin':
      //     users.filters.admin = true;
      //     break;
      //   case 'approvedAccount':
      //     users.filters.approvedAccount = true;
      //     break;
      // }
      this.users.filters.admin = false;
      this.users.filters.all = false;
      this.users.filters.student = false;
      this.users.filters.blocked = false;

      this.users.filters[val] = true;
      this.getUserData();
    },
    downloadUserCSV() {
      let x = this;
      let data = x.users.list;
      let csvData = data.map((item) => {
        return {
          "Display Name": item.displayName,
          Email: item.email,
          Phone: item.phone || "",
          Address: item.address || "",
          // "Account Type": item.accountType,
          Groups: item.groups.join(', ') || "",
          // Permissions: item.permissions,
          // "User ID": item.id,
          // "Created On": x.formatDate(item.createdOn),
        };
      });
      let csv = Papa.unparse(csvData);
      // console.log(csv);
      x.downloadCSV("users.csv", csv);
    },
    downloadCSV(filename, data) {
      let blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
      let link = document.createElement("a");
      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  // watch: {
  //   "users.filters.admin"() {
  //     this.getUserData();
  //   },
  // },
  computed: {
    selectedUser() {
      if (this.users.selected != null) {
        return this.users.list[this.users.selected];
        // return _.find(this.users.list, { email: this.users.selected });
        //   return _.filter(this.users.list, { 'id': this.users.selected });
      } else {
        return null;
      }
    },
    filteredUsers() {
      var x = this;
      return _.filter(this.users.list, function(item) {
        return _.includes(
          _.lowerCase(`${item.displayName} ${item.email}`),
          x.users.search
        );
      });
    },
  },
  mounted() {
    this.getUserData();
  },
};
</script>
<style lang="scss" scoped>
.v-center{
  align-items:center;
}
.input-text,
.input-select {
  font-size: var(--font-p);
  font-weight: var(--font-regular);
  padding: 4px;
  border-radius: 3px;
  border: 0;
  background-color: #f1f1f1;
}
.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}
[el="tabs"] {
  user-select: none;
}
[el="table"],
[el|="table"] {
  --control-border: 0px;
}
[el="table"] tbody tr {
  height: 46.4px;
  /* content-visibility:auto;
    contain-intrinsic-size:1px 46.4px; */
}
[el="table"] tr:hover,
[el|="table"] tr:hover,
[el="table"] tr.active {
  /* box-shadow: 0 0 0 1px var(--color-sky); */
  outline: 1px solid var(--color-sky);
  outline-offset: -1px;
}
[el="table"] tr.active {
  background-color: var(--color-sky-5);
}
td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
thead th {
  background: white;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 0 var(--color-25);
}
.table-action thead th {
  box-shadow: 0 1px 0 var(--color-25), 0 1px 0 var(--color-25) inset;
}
.dynamic-table1 {
  display: grid;
  background: #ccc;
  height: 550px;
  display: grid;
  grid-template-columns: 1fr 0px;
  grid-template-rows: max-content 1fr;
  grid-gap: 1px;
  overflow: hidden;
      box-shadow: 0 3px 6px rgb(0 0 0 / 8%);
  border-radius: 12px;
}
.dynamic-table1.selected {
  grid-template-columns: 1fr 550px;
}
.dynamic-table1 > * {
  background: #fff;
  position: relative;
}
.search .material-icons {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-40);
  transition: 0.2s;
  -webkit-text-fill-color: currentColor;
}
.search:hover .material-icons,
.search:focus .material-icons {
  color: var(--color-sky);
}
.close {
  color: var(--color-40);
  -webkit-text-fill-color: currentColor;
  cursor: pointer;
  transition: 0.2s;
}
.close:hover {
  color: var(--color-sky);
}
.v-center {
  align-items: center;
}
tr.bold > td {
  font-weight: var(--font-medium);
}
.table-action th:first-child,
.table-action tr td:first-child {
  padding-left: 54px;
}
.table-action tr td:first-child {
  position: relative;
}
.table-action th:first-child .material-icons,
.table-action tr td:first-child .material-icons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 14px;
}

.thumbnail {
  width: 100%;
  height: 90px;
  object-fit: contain;
  opacity: 0.07;
  object-position: center;
}
.status {
  --size: 20px;
  height: var(--size);
  width: var(--size);
  display: inline-block;
  position: absolute;
  transform: translateY(-50%) translateX(-100%);
}
.text-right {
  text-align: right;
}
.ce-header {
  font-weight: bold;
  font-size: 1.5rem;
}
[el^=table]{
  --border:0;
  border-radius:0;
}

.tagContainer{
  width:100%;
  display: flex;
  flex-wrap: wrap;
}
.tagContainer > *{
  background-color:hsla(0, 0%, 0%, 0.07);
  color:#222;
  font-weight:500;
  font-size: 16px;
  border-radius: 5px;
  padding: 4px 8px;
  transition:0.2s;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
}
.tagContainer > *:hover{
  background-color:hsla(0, 0%, 0%, 0.25);
  color:#0e0e0e;
}
.tagContainer > *.active{
  background-color:#2facee;
  color:white;
}
</style>
